import { Icons } from '@pages/LogbookPage/icons';
import { LocalStorageKeys } from '@common/constants';

type UseLocationReturnType = {
  location: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Logo: any;
};

export default function useHBHLocation(): UseLocationReturnType {
  const rowLocation = localStorage.getItem(LocalStorageKeys.LOCATION)?.split('|');
  const location = rowLocation ? `${rowLocation[2]}, ${rowLocation[1]}` : '';
  const agency = rowLocation && rowLocation[0];
  const Logo = Icons.icon(agency);
  return { location, Logo };
}
